import { registrarEvento } from "../core/auditLog.js";
import { abrirSeguridadMFA, confirmarEnrollMFA, iniciarEnrollMFA, quitarFactorMFA, renderModalMFA } from "../auth/mfa.js";
import { cerrarSesion } from "../auth/session.js";
import { ajustarInventario, crearAsiento, generarAsientoCobroFactura, generarAsientoCompra } from "../core/accounting.js";
import { desgloseIVA, ivaPct, leerValorOpcion } from "../core/iva.js";
import { cargarConsecutivosActuales, deleteData, establecerNumeroDoc, fechaEstaCerrada, getParametrosNomina, saveAlertConfig, saveData, saveIAConfig, siguienteNumeroDoc, siguienteNumeroRaw } from "../core/cloudSync.js";
import { liquidarEmpleado } from "../core/payroll.js";
import { BRAND, C, DEFAULT_TABLA_COMISIONES, DOC_INFO, ESTADOS, KEYS, MEDIOS_PAGO, PUC_DEFAULT } from "../core/config.js";
import { state } from "../core/state.js";
// El costo de un KIT se deriva de sus partes: un costo digitado en la ficha de
// un kit envejece en cuanto sube uno de sus componentes.
import { costoBaseProducto } from "../core/kitCatalogo.js";
import { btnStyle, escapeHTML, fmtCOP, fmtDate, formatMiles, genId, inputStyle, normalize, parseNumber, searchFilter, today } from "../core/utils.js";
import { exportCertificadoRetencion, exportPDF, exportPDFFactura, exportPDFNotaCredito } from "../export/pdf.js";
import { buildAlertasMensajeUnificado, buildAlertasWhatsAppLink, getAlertas, getAlertasEntradas, getAlertasKeysByFiltro, getAlertasNumerosEnvio } from "../modules/alertas.js";
import { enviarInstruccionIA, toggleIAMic } from "../modules/asistenteIA.js";
import { cargarAuditoria } from "../modules/auditoria.js";
import { attachComisionesListeners, calcComisionPct, getComisionEntradaOP, getTablaComisiones, liquidarComisiones, saveTablaComisiones } from "../modules/comisiones.js";
import { showRevalidacionModal } from "../modules/configuracion.js";
import { exportExogenaCSV, renderCuentaPUCModal } from "../modules/contabilidad.js";
import { confirmarPagoOCP, ocpTotalmenteIngresada, renderAnticiposOP, renderCargarFirmadoRC, renderIngresoMercanciaModal, renderLiquidacionModal, renderPagoModal, showLiquidacionOP, showPagarOCP } from "../modules/cxp.js";
import { avisoReenvioHTML, enviarADataico, facturarLocal, getDataicoConfig, handleRetPctInput, showFacturarDataico , handleFactOPCantInput} from "../modules/dataico.js";
import { aplicarCambioEstadoDoc, aportaATotales, avisoFaltantesStock, convertDoc, costoUnitarioEscala, faltantesStockOP, findFieldByKey, programarAutoguardado, getCantidadRemisionadaOP, getConvertedToList, getLiquidacionOP, getMontoPagadoOCP, getNextFieldKey, getSaldoOCP, handleCrearProductoFieldInput, handleCrearProductoImagenChange, handleLookupInput, renderConfirmarCrearProductoModal, renderDocFormModal, renderDocViewModal, renderMultiOcpModal, showConvertOpMultiOcp, showDocForm } from "../modules/documentos.js";
import { aprenderVia } from "../modules/cuentasPagar.js";
import { getSaldoFactura, getTotalNC, showAbonarFactura, showCrearNotaCredito, showVerFactura } from "../modules/facturas.js";
import { avisoCorreoFEHTML, renderMaestroFormModal, showMaestroForm } from "../modules/maestros.js";
import { renderNotaCreditoModal } from "../modules/notasCredito.js";
import { addCatalogProductToDoc, renderProductSearchModal, showProductSearch } from "../modules/productSearch.js";
import { calcularFechaPorDias, calcularMargenTotal } from "../modules/reportes.js";
import { applyMobileLayout, navigateTo, render } from "./app.js";
import { attachEditoresRicos } from "./editorRico.js";
import { showConfirmDelete } from "./modals.js";
import { comprimirImagen } from "../core/storage.js";

export function attachListeners() {
  // Comisiones
  if (state.page === "comisiones") attachComisionesListeners();

  // ─── ATAJOS DE TECLADO (registro único global) ──────────────────────
  if (!window.__mathizKeyListenerAttached) {
    document.addEventListener("keydown", function(e) {
      const tag = document.activeElement ? document.activeElement.tagName : "";
      const isInputFocused = ["INPUT","TEXTAREA","SELECT"].includes(tag);

      // Escape: cerrar modal o búsqueda global
      if (e.key === "Escape") {
        if (state.modal) {
          state.modal = null;
          render();
          return;
        }
        if (state.globalSearch) {
          state.globalSearch = "";
          render();
          return;
        }
      }

      // Ctrl+S / Cmd+S: guardar formulario activo
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        if (state.editingDoc) {
          e.preventDefault();
          const saveBtn = document.querySelector("[data-action='save-doc'][data-finalize='1']") ||
                          document.querySelector("[data-action='save-doc']");
          if (saveBtn) saveBtn.click();
        }
        return;
      }

      // Ctrl+N / Cmd+N: nuevo documento en el módulo activo
      if ((e.ctrlKey || e.metaKey) && e.key === "n") {
        if (!isInputFocused && !state.modal && DOC_INFO[state.page]) {
          e.preventDefault();
          showDocForm(state.page, null);
        }
        return;
      }

      // Ctrl+F / Cmd+F: enfocar búsqueda global
      if ((e.ctrlKey || e.metaKey) && e.key === "f") {
        const searchInput = document.getElementById("global-search-input");
        if (searchInput) {
          e.preventDefault();
          searchInput.focus();
          searchInput.select();
        }
        return;
      }
    });
    window.__mathizKeyListenerAttached = true;
  }

  // Navegación
  document.querySelectorAll("[data-nav]").forEach(el => {
    el.addEventListener("click", () => navigateTo(el.dataset.nav));
  });

  // Acciones - Usando event delegation para elementos dinámicos (solo una vez)
  if (!window.__mathizActionListenerAttached) {
    document.addEventListener("click", function(e) {
      const el = e.target.closest("[data-action]");
      if (el && (el.tagName === "BUTTON" || el.dataset.action)) {
        // Los campos de formulario (select/input/textarea) disparan su acción
        // por "input"/"change" (listener de abajo), NO por clic: ejecutar la
        // acción en el clic re-renderiza el DOM y destruye el elemento justo
        // cuando el navegador está abriendo su lista de opciones (el <select>
        // se cierra solo antes de poder elegir).
        if (["SELECT", "INPUT", "TEXTAREA"].includes(el.tagName)) return;
        // prevent-close es solo un contenedor: NO ejecutar handleAction (haría stopPropagation
        // en fase de captura y mataría los onclick inline internos, p.ej. el modal de ingreso de mercancía).
        // closest() ya se detiene aquí, así que el clic interno nunca llega a close-modal-bg.
        if (el.dataset.action === "prevent-close") return;
        // No cerrar el modal si el usuario está seleccionando texto (drag termina en el fondo)
        if (el.dataset.action === "close-modal-bg") {
          const sel = window.getSelection ? window.getSelection() : null;
          if (sel && sel.toString().length > 0) return;
          if (e.target !== el) return; // solo cerrar si el clic fue realmente sobre el fondo
        }
        handleAction.call(el, e);
      }
    }, true); // Usar capture phase para más confiabilidad
    window.__mathizActionListenerAttached = true;
  }

  // Acciones sobre select/input con data-action (ej. un <select> que debe
  // recalcular algo al cambiar, o un campo que debe sincronizarse a `state`
  // antes de que un render() reconstruya el formulario): mismo registro que
  // los clics, disparado por "input"/"change" en vez de "click".
  if (!window.__mathizActionChangeListenerAttached) {
    const onFieldEvent = function(e) {
      const el = e.target.closest("[data-action]");
      if (el && (el.tagName === "SELECT" || el.tagName === "INPUT")) {
        handleAction.call(el, e);
      }
    };
    document.addEventListener("input", onFieldEvent, true);
    document.addEventListener("change", onFieldEvent, true);
    window.__mathizActionChangeListenerAttached = true;
  }

  // Inputs del formulario
  document.querySelectorAll("[data-form]").forEach(el => {
    el.addEventListener("input", handleFormInput);
    el.addEventListener("change", handleFormInput);
  });

  // El aviso del correo de facturación electrónica se repinta mientras se
  // escribe, sin re-renderizar el modal (eso perdería el cursor). Sin esto el
  // aviso solo aparecía al reabrir la ficha, que es justo cuando ya no se está
  // mirando.
  // Misma idea en el reenvío de una factura: avisar mientras se escribe.
  const _campoRe = document.getElementById("reenvio-correo");
  const _avisoRe = document.getElementById("reenvio-aviso");
  if (_campoRe && _avisoRe) {
    _campoRe.addEventListener("input", () => { _avisoRe.innerHTML = avisoReenvioHTML(_campoRe.value); });
  }

  const _campoFE = document.querySelector('[data-form="email_fe"]');
  const _avisoFE = document.getElementById("aviso-email-fe");
  if (_campoFE && _avisoFE) {
    _campoFE.addEventListener("input", () => { _avisoFE.innerHTML = avisoCorreoFEHTML(_campoFE.value); });
  }

  attachItemDragDrop();

  // Campos de texto con formato (notas del documento). No son [data-form]:
  // guardan HTML saneado, no el `value` de un input.
  attachEditoresRicos((campo, valor) => {
    if (!state.editingDoc) return;
    state.editingDoc[campo] = valor;
    programarAutoguardado();
  });

  // Lookup inputs (combobox con datalist: cliente / proveedor)
  // Listeners para campos de lookup (cliente/proveedor) - MEJORADO
  document.querySelectorAll("[data-form-lookup]").forEach(el => {
    // Evento de input mientras escribe
    el.addEventListener("input", handleLookupInput);
    // Evento de cambio
    el.addEventListener("change", handleLookupInput);
    // Evento cuando pierde foco - ESTE ES EL MÁS IMPORTANTE
    el.addEventListener("blur", () => {
      // Capturar, ANTES de re-renderizar, cuál es el siguiente campo enfocable del formulario
      const nextKey = getNextFieldKey(el);
      setTimeout(() => {
        handleLookupInput({ target: el });
        // Renderizar de nuevo para asegurar que se ve el cambio.
        // OJO: si el blur lo causó el clic en "➕ Crear cliente" o en
        // "✏️ Cotizar sin crearlo", el mini-modal correspondiente ya está
        // abierto y este re-render lo pisaría.
        if (state.editingDoc && !state._crearClienteDraft && !state._clienteLibreDraft) {
          renderDocFormModal();
          // Restaurar el foco en el siguiente campo (permite continuar con Tab)
          const target = findFieldByKey(nextKey);
          if (target) {
            target.focus();
            if (typeof target.select === "function") target.select();
          }
        }
      }, 50);
    });
  });

  // Inputs de items
  document.querySelectorAll("[data-item][data-field]").forEach(el => {
    el.addEventListener("input", handleItemInput);
    el.addEventListener("change", handleItemInput);
  });

  // Inputs de conceptos de costo (OP)
  document.querySelectorAll("[data-costo-concepto][data-costo-field]").forEach(el => {
    el.addEventListener("input", handleCostoConceptoInput);
    el.addEventListener("change", handleCostoConceptoInput);
  });

  // Inputs de los costos por línea de la cotización
  document.querySelectorAll("[data-costo-linea][data-costo-field]").forEach(el => {
    el.addEventListener("input", handleCostoLineaInput);
    el.addEventListener("change", handleCostoLineaInput);
  });

  // Escalas de cantidad de una línea de la cotización
  document.querySelectorAll("[data-escala][data-escala-field]").forEach(el => {
    el.addEventListener("input", handleEscalaInput);
    el.addEventListener("change", handleEscalaInput);
  });

  // Cantidades a facturar por anticipado, en el selector de facturación de la OP
  document.querySelectorAll("[data-fact-op-cant]").forEach(el => {
    el.addEventListener("input", handleFactOPCantInput);
    el.addEventListener("change", handleFactOPCantInput);
  });

  // % de retención en la vista previa de la factura
  document.querySelectorAll("[data-ret-pct]").forEach(el => {
    el.addEventListener("input", handleRetPctInput);
    el.addEventListener("change", handleRetPctInput);
  });

  // Inputs de "otros costos" en el modal de Liquidación de OP
  document.querySelectorAll("[data-liq-concepto][data-liq-field]").forEach(el => {
    el.addEventListener("input", handleLiqCostoInput);
    el.addEventListener("change", handleLiqCostoInput);
  });

  // Inputs de fechas de entrega (OP)
  document.querySelectorAll("[data-entrega][data-entrega-field]").forEach(el => {
    el.addEventListener("input", handleEntregaInput);
    el.addEventListener("change", handleEntregaInput);
  });

  // Inputs de contactos adicionales (cliente)
  document.querySelectorAll("[data-desc-idx][data-desc-field]").forEach(el => {
    el.addEventListener("input", handleDescFinInput);
    el.addEventListener("change", handleDescFinInput);
  });

  // Componentes de un producto kit (la receta del "Set escolar")
  document.querySelectorAll("[data-comp-kit][data-comp-field]").forEach(el => {
    el.addEventListener("input", handleCompKitInput);
    el.addEventListener("change", handleCompKitInput);
  });

  document.querySelectorAll("[data-contacto][data-contacto-field]").forEach(el => {
    el.addEventListener("input", handleContactoInput);
    el.addEventListener("change", handleContactoInput);
  });

  // Ajustes manuales por empleado en una liquidación de nómina en curso
  document.querySelectorAll("[data-nomina-ajuste][data-nomina-campo]").forEach(el => {
    el.addEventListener("change", handleNominaAjusteInput);
  });

  // Inputs del modal de Nota Crédito
  document.querySelectorAll("[data-nc-item]").forEach(el => {
    el.addEventListener("change", handleNCItemInput);
  });
  const ncMotivo = document.querySelector("[data-nc-motivo]");
  if (ncMotivo) {
    ncMotivo.addEventListener("change", (e) => {
      if (!state.editingNC) return;
      // El value es el código DIAN (reason) que espera Dataico; el texto visible
      // es la etiqueta humana que se guarda como motivo del documento.
      state.editingNC.reason = e.target.value;
      state.editingNC.motivo = e.target.selectedOptions[0] ? e.target.selectedOptions[0].text : e.target.value;
    });
  }

  // Inputs del modal de conversión OP → varias OCP
  document.querySelectorAll("[data-multiocp-item][data-multiocp-field]").forEach(el => {
    el.addEventListener("change", handleMultiOcpItemInput);
  });
  document.querySelectorAll("[data-multiocp-grupo]").forEach(el => {
    el.addEventListener("input", handleMultiOcpProveedorInput);
    el.addEventListener("change", handleMultiOcpProveedorInput);
  });

  // Inputs de búsqueda
  document.querySelectorAll("[data-search]").forEach(el => {
    el.addEventListener("input", handleSearchInput);
  });

  // Filtros de reportes
  document.querySelectorAll("[data-filter]").forEach(el => {
    el.addEventListener("change", handleFiltroReporte);
    el.addEventListener("input", handleFiltroReporte);
  });

  // Selector de OP en Remisiones
  document.querySelectorAll("[data-form-op-selector]").forEach(el => {
    el.addEventListener("change", handleOpSelectorRC);
  });

  // Inputs del modal de pago
  document.querySelectorAll("[data-pago]").forEach(el => {
    el.addEventListener("input", handlePagoInput);
    el.addEventListener("change", handlePagoInput);
  });

  // Import file
  const importFile = document.getElementById("import-file");
  if (importFile) {
    importFile.addEventListener("change", handleImportFile);
  }

  // Pegar una imagen (Ctrl+V) con la zona de imagen en pantalla. El listener se
  // registra una sola vez y decide el destino en el momento de pegar.
  if (!window.__mathizPasteImagenAttached) {
    document.addEventListener("paste", async (ev) => {
      const destino = zonaImagenVisible();
      if (!destino) return;
      const file = imagenDeTransferencia(ev.clipboardData);
      if (!file) return;
      ev.preventDefault();
      await usarImagenProducto(file, destino);
    });
    window.__mathizPasteImagenAttached = true;
  }

  // Arrastrar la imagen sobre la zona
  document.querySelectorAll("[data-img-zona]").forEach(zona => {
    const pintar = (on) => {
      zona.style.background = on ? "#eff6ff" : "#f8fafc";
      zona.style.borderColor = on ? C.blue : C.border;
    };
    zona.addEventListener("dragover", (ev) => { ev.preventDefault(); pintar(true); });
    zona.addEventListener("dragleave", () => pintar(false));
    zona.addEventListener("drop", async (ev) => {
      ev.preventDefault();
      pintar(false);
      const file = imagenDeTransferencia(ev.dataTransfer);
      if (!file) { alert("⚠️ Eso que arrastraste no es una imagen."); return; }
      await usarImagenProducto(file, zona.dataset.imgZona);
    });
  });

  // ─── La foto del producto entra SIEMPRE por usarImagenProducto ───────────
  // Había dos caminos con dos políticas distintas: el de Maestros comprimía y
  // el de la creación rápida desde la cotización guardaba el archivo crudo. Por
  // ahí entraron 52 PNG de 616 KB de promedio —31 de los 35 MB del catálogo—
  // que desbordaron la cuota del navegador y dejaron a Natalia viendo un solo
  // producto. Pegar y arrastrar ya pasaban por aquí; ahora los selectores de
  // archivo también, así que la compresión no depende de por dónde se entró.
  [["producto-imagen-input", "maestro"],
   ["crear-producto-imagen-input", "crearProducto"]].forEach(([id, destino]) => {
    const input = document.getElementById(id);
    if (!input) return;
    input.addEventListener("change", async (e) => {
      const file = e.target.files && e.target.files[0];
      if (file) await usarImagenProducto(file, destino);
    });
  });
  // Categoría / unidad de empaque (creación rápida desde ítem de cotización)
  document.querySelectorAll("[data-crear-prod-field]").forEach(el => {
    el.addEventListener("input", handleCrearProductoFieldInput);
    el.addEventListener("change", handleCrearProductoFieldInput);
  });
  // Responsive: adaptar layout para móvil
  applyMobileLayout();
  // Conectar observer de modales
  if (window.__mobObserver && window.innerWidth <= 768) {
    const rootEl = document.getElementById("root");
    if (rootEl) {
      window.__mobObserver.disconnect();
      window.__mobObserver.observe(rootEl, { childList: true, subtree: false });
    }
  }


}

// ─── La imagen del producto: archivo, portapapeles o arrastre ───────────────
// Las tres formas terminan aquí. Se comprime a 800px por el lado largo (una
// captura de pantalla o una foto de cámara quedan en decenas de KB) y se guarda
// en el borrador que esté abierto, sea la creación rápida desde la cotización o
// la ficha del producto en Maestros.
export async function usarImagenProducto(file, destino) {
  if (!file) return false;
  if (!String(file.type || "").startsWith("image/")) {
    alert("⚠️ Eso que pegaste no es una imagen. Copia la imagen y vuelve a intentar.");
    return false;
  }
  if (file.size > 25 * 1024 * 1024) { alert("⚠️ La imagen es demasiado grande (máximo 25MB)."); return false; }
  try {
    const comprimida = await comprimirImagen(file, 800, 0.82);
    if (destino === "crearProducto") {
      if (!state._crearProductoDraft) return false;
      state._crearProductoDraft.imagen = comprimida;
      renderConfirmarCrearProductoModal();
    } else {
      if (!state.editingMaestro) return false;
      state.editingMaestro.imagen = comprimida;
      renderMaestroFormModal();
    }
    return true;
  } catch (err) {
    alert("⚠️ No se pudo procesar la imagen: " + (err.message || err));
    return false;
  }
}

// La primera imagen de un portapapeles o de un arrastre. Una captura de pantalla
// llega como "file" dentro de items; un archivo arrastrado, en files.
export function imagenDeTransferencia(dt) {
  if (!dt) return null;
  const items = dt.items ? Array.from(dt.items) : [];
  const item = items.find(x => x.kind === "file" && String(x.type || "").startsWith("image/"));
  if (item && item.getAsFile) {
    const f = item.getAsFile();
    if (f) return f;
  }
  const files = dt.files ? Array.from(dt.files) : [];
  return files.find(f => String(f.type || "").startsWith("image/")) || null;
}

// La zona visible en pantalla decide a dónde va lo que se pegue: no hace falta
// poner el cursor en ningún campo, que es justo lo que se quiere después de
// tomar una captura.
function zonaImagenVisible() {
  const z = document.querySelector("[data-img-zona]");
  return z ? z.dataset.imgZona : null;
}

// Se conserva por compatibilidad (está expuesta en window), pero ya no decide
// nada por su cuenta: delega en la única puerta.
export async function handleProductImageUpload(e) {
  const file = e.target.files && e.target.files[0];
  if (file) await usarImagenProducto(file, "maestro");
}

export function handlePagoInput(e) {
  if (!state.editingPago) return;
  state.editingPago[e.target.dataset.pago] = e.target.value;
  if (e.target.dataset.pago === "medio") renderPagoModal();
}

export function handleSearchInput(e) {
  const id = e.target.dataset.search;
  const value = e.target.value;

  if (id === "search-maestros") {
    state.searches.maestros = value;
    render();
    // Restaurar foco
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-maestros");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "search-cxp") {
    state.searches.cxp = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-cxp");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "search-piloto") {
    state.searches.piloto = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-piloto");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "search-controlop") {
    state.searches.controlop = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-controlop");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "search-empleados") {
    state.searches.empleados = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-empleados");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "search-inventario") {
    state.searches.inventario = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById("search-inventario");
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id && id.startsWith("search-docs-")) {
    const tipo = id.replace("search-docs-", "");
    if (!state.searches.docs) state.searches.docs = {};
    state.searches.docs[tipo] = value;
    render();
    setTimeout(() => {
      if (window.innerWidth > 768) {
        const el = document.getElementById(id);
        if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }
    }, 0);
  } else if (id === "product-search-input") {
    state.productSearch = value;
    renderProductSearchModal();
  } else if (id === "global") {
    state.globalSearch = value;
    render();
    setTimeout(() => {
      const el = document.getElementById("global-search-input");
      if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
    }, 0);
  }
}

export function handleFiltroReporte(e) {
  const field = e.target.dataset.filter;
  const value = e.target.value;
  
  if (!state.reporteFiltros) state.reporteFiltros = {};
  state.reporteFiltros[field] = value;
  render();
}

export function handleOpSelectorRC(e) {
  const opId = e.target.value;
  if (!opId) {
    state.editingDoc.items = [];
    state.editingDoc._origen = null;
    state.editingDoc.cliente_id = null;
    renderDocFormModal();
    return;
  }

  const op = state.data.pedidos.find(o => o.id === opId);
  if (!op) return;

  // Remisionar saca mercancía del inventario: si no alcanza, no se puede — el
  // mismo criterio que el botón "→ RS" de la orden, para que los dos caminos
  // digan lo mismo (antes este los dejaba pasar y aquel escondía el botón).
  const faltantes = faltantesStockOP(op, state.editingDoc.id || null);
  if (faltantes.length > 0) {
    alert("⚠️ " + avisoFaltantesStock(op, faltantes));
    e.target.value = "";
    state.editingDoc.items = [];
    state.editingDoc._origen = null;
    state.editingDoc.cliente_id = null;
    renderDocFormModal();
    return;
  }

  // Guardar origen y cliente
  state.editingDoc._origen = { id: op.id, numero: op.numero, fecha: op.fecha, tipo: "OP" };
  state.editingDoc.cliente_id = op.cliente_id;

  // Cargar líneas pendientes (descontando lo ya remisionado en otras RS de esta OP)
  const excludeId = state.editingDoc.id || null;
  const lineasPendientes = [];
  (op.items || []).forEach(item => {
    const cantOP = parseNumber(item.cantidad) || 0;
    const cantRemisionada = getCantidadRemisionadaOP(op.id, item.articulo, excludeId);
    const cantPendiente = cantOP - cantRemisionada;

    if (cantPendiente > 0) {
      lineasPendientes.push({
        articulo: item.articulo || "",
        descripcion: item.descripcion || "",
        referencia: item.referencia || "",
        cantidad: cantPendiente,
        bolsas: 1,
        // Las observaciones son del usuario: llegan vacías. Lo pendiente de la
        // OP se muestra bajo la cantidad (ayuda en pantalla), no se guarda en
        // el documento ni se imprime en la remisión.
        observaciones: ""
      });
    }
  });

  state.editingDoc.items = lineasPendientes;
  renderDocFormModal();
}

// Módulos con imports circulares hacia este archivo llaman registerActions()
// en su propio nivel superior, lo que puede ejecutarse mientras este módulo
// todavía está resolviendo sus propios imports (antes de llegar a un
// `const __actionRegistry = new Map()`). Por eso el registro se construye de
// forma perezosa en el primer uso, en vez de confiar en el orden de
// inicialización entre módulos.
var __actionRegistry;
function getActionRegistry() {
  if (!__actionRegistry) __actionRegistry = new Map();
  return __actionRegistry;
}

export function registerActions(map) {
  const registry = getActionRegistry();
  for (const [name, fn] of Object.entries(map)) {
    if (registry.has(name)) {
      throw new Error(`Acción duplicada registrada dos veces: "${name}"`);
    }
    registry.set(name, fn);
  }
}

// Ejecuta una acción registrada sin que medie un clic. Sirve para reanudar un
// flujo que se interrumpió a mitad: por ejemplo, el guardado de una cotización
// que se detuvo para preguntar a quién va dirigida y, respondida la pregunta,
// tiene que continuar exactamente donde iba.
export async function ejecutarAccion(nombre, datos = {}) {
  const fn = getActionRegistry().get(nombre);
  if (!fn) {
    console.error(`❌ Acción sin handler registrado: "${nombre}"`);
    return;
  }
  return fn(datos, null, null);
}

export async function handleAction(e) {
  e.stopPropagation();
  const el = this && this.dataset ? this : e.currentTarget;
  const action = el.dataset.action;
  const d = el.dataset;
  const fn = getActionRegistry().get(action);
  if (!fn) {
    console.error(`❌ Acción sin handler registrado: "${action}"`);
    return;
  }
  return fn(d, el, e);
}

registerActions({
  // El botón de pegar: útil en el celular y cuando no se sabe que Ctrl+V sirve.
  // La API del portapapeles necesita permiso del navegador; si lo niega o no la
  // soporta, se explica el atajo en vez de dejar el botón sin hacer nada.
  "pegar-imagen": async (d, el, e) => {
      const destino = d.destino || "crearProducto";
      try {
        if (!navigator.clipboard || !navigator.clipboard.read) throw new Error("sin soporte");
        const items = await navigator.clipboard.read();
        for (const item of items) {
          const tipo = (item.types || []).find(t => t.startsWith("image/"));
          if (!tipo) continue;
          const blob = await item.getType(tipo);
          if (await usarImagenProducto(new window.File([blob], "captura.png", { type: tipo }), destino)) return;
        }
        alert("⚠️ No hay ninguna imagen copiada en el portapapeles. Toma la captura y vuelve a pulsar Pegar.");
      } catch {
        alert("Este navegador no deja leer el portapapeles con un botón.\n\nHaz la captura y pulsa Ctrl+V con esta ventana abierta: funciona igual.");
      }
      return;},

  "clear-search": (d, el, e) => {{
      const target = d.target;
      if (target === "search-maestros") state.searches.maestros = "";
      else if (target === "search-cxp") state.searches.cxp = "";
      else if (target === "search-inventario") state.searches.inventario = "";
      else if (target && target.startsWith("search-docs-")) {
        const tipo = target.replace("search-docs-", "");
        if (state.searches.docs) state.searches.docs[tipo] = "";
      }
      render();
      return;
    }},
});


// ─── Reordenar los ítems arrastrándolos ──────────────────────────────────────
// El orden de los ítems es el que sale impreso en la cotización, así que se
// puede acomodar a conveniencia después de cargarlos todos.
//
// El arrastre arranca SOLO desde el asa (la columna del número): si la fila
// entera fuera arrastrable, seleccionar texto dentro de un campo se convertiría
// en un arrastre y no se podría editar a gusto.
//
// La fila de "costos de la línea" no lleva data-item-row, así que no es destino
// de soltado; al reordenar se redibuja todo y vuelve a quedar bajo su ítem.
function attachItemDragDrop() {
  const filas = Array.from(document.querySelectorAll("tr[data-item-row]"));
  if (filas.length < 2) return;
  let origen = null;

  const limpiar = () => filas.forEach(f => { f.style.background = ""; f.style.opacity = ""; });

  filas.forEach(tr => {
    const asa = tr.querySelector("[data-item-asa]");
    if (asa) {
      // draggable se activa solo mientras se agarra el asa.
      asa.addEventListener("mousedown", (e) => {
        // Los botones ▲▼ viven dentro del asa: pulsarlos no debe iniciar un arrastre.
        if (e.target.closest("button")) return;
        tr.draggable = true;
      });
      asa.addEventListener("mouseup", () => { tr.draggable = false; });
    }

    tr.addEventListener("dragstart", (e) => {
      origen = Number(tr.dataset.itemRow);
      e.dataTransfer.effectAllowed = "move";
      try { e.dataTransfer.setData("text/plain", String(origen)); } catch { /* navegador quisquilloso */ }
      tr.style.opacity = ".4";
    });

    tr.addEventListener("dragend", () => {
      tr.draggable = false;
      origen = null;
      limpiar();
    });

    tr.addEventListener("dragover", (e) => {
      if (origen == null) return;
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";
      const destino = Number(tr.dataset.itemRow);
      filas.forEach(f => { if (f !== filas[origen]) f.style.background = ""; });
      if (destino !== origen) tr.style.background = "#e0f2fe";
    });

    tr.addEventListener("drop", (e) => {
      e.preventDefault();
      const destino = Number(tr.dataset.itemRow);
      const items = state.editingDoc && state.editingDoc.items;
      if (origen == null || destino === origen || !items) { limpiar(); return; }
      const [movido] = items.splice(origen, 1);
      items.splice(destino, 0, movido);
      origen = null;
      renderDocFormModal();   // redibuja con la numeración nueva
    });
  });
}

export function handleFormInput(e) {
  const field = e.target.dataset.form;
  const value = e.target.value;
  if (state.editingDoc) {
    state.editingDoc[field] = value;
    programarAutoguardado();   // se guarda solo unos segundos después de escribir
    if (field === "_dias_vigencia") {
      const calc = calcularFechaPorDias(value);
      state.editingDoc.fecha_vigencia = calc ? calc.fecha : "";
      const box = document.getElementById("vigencia-info");
      if (box) {
        if (value === "" || value == null || !calc) {
          box.innerHTML = "Escribe el número de días de vigencia a partir de hoy.";
        } else {
          const base = `Fecha de vigencia: <strong>${fmtDate(calc.fecha)}</strong> (${calc.nombreDia})`;
          box.innerHTML = calc.esFinDeSemana
            ? base + ` <span style="color:${C.red};font-weight:700;">⚠️ Cae en día no hábil (${calc.nombreDia})</span>`
            : base;
        }
      }
      return;
    }
    if (field === "_contacto_idx") {
      renderDocFormModal();
      return;
    }
    // No re-renderizar el modal completo en cada cambio - solo actualizar
  } else if (state.editingMaestro) {
    const val = e.target.dataset.checkbox ? e.target.checked : value;
    state.editingMaestro[field] = val;
    if (state.editingMaestroKey === "productos" && (field === "costo" || field === "margen")) {
      const costoNum = parseNumber(state.editingMaestro.costo) || 0;
      const margenNum = parseNumber(state.editingMaestro.margen) || 0;
      const complemento = 1 - (margenNum / 100);
      const precioCalc = complemento > 0 ? Math.round(costoNum / complemento) : 0;
      state.editingMaestro.precio_venta = precioCalc;
      const box = document.getElementById("precio-venta-calculado");
      if (box) box.textContent = formatMiles(precioCalc);
      const hidden = document.querySelector('input[type="hidden"][data-form="precio_venta"]');
      if (hidden) hidden.value = precioCalc;
    }
    // Al elegir el régimen de IVA hay que repintar la ficha: lo que cambia es
    // la EXPLICACIÓN de lo que implica (descontables, prorrateo), y sin esto
    // solo aparecía al reabrir el producto — justo cuando ya no se está
    // decidiendo. El valor ya quedó guardado arriba, así que el repintado lo
    // muestra seleccionado.
    // Marcar "es un KIT" cambia media ficha: aparece el editor de componentes,
    // el costo deja de digitarse y el stock pasa a calcularse. Hay que repintar.
    if (state.editingMaestroKey === "productos" && field === "es_kit") {
      showMaestroForm("productos", state.editingMaestro);
      return;
    }
    if (state.editingMaestroKey === "productos" && field === "iva_regimen") {
      // Se traduce YA a los dos campos que se guardan: si se repintara con solo
      // `iva_regimen` puesto, la ficha volvería a leer `iva_tipo` —todavía sin
      // cambiar— y el selector se vería en la opción anterior.
      Object.assign(state.editingMaestro, leerValorOpcion(val));
      showMaestroForm("productos", state.editingMaestro);
    }
  }
}

export function handleEntregaInput(e) {
  const idx = parseInt(e.target.dataset.entrega);
  const field = e.target.dataset.entregaField;
  if (!state.editingDoc._entregas) state.editingDoc._entregas = [];
  if (!state.editingDoc._entregas[idx]) state.editingDoc._entregas[idx] = {};
  state.editingDoc._entregas[idx][field] = e.target.value;
}

export function handleDescFinInput(e) {
  if (!state.editingMaestro) return;
  const idx = parseInt(e.target.dataset.descIdx);
  const field = e.target.dataset.descField;
  if (!Array.isArray(state.editingMaestro.descuentos_financieros)) state.editingMaestro.descuentos_financieros = [];
  if (!state.editingMaestro.descuentos_financieros[idx]) state.editingMaestro.descuentos_financieros[idx] = {medio:"transferencia",pct:0,dias:0};
  const val = (field==="pct"||field==="dias") ? (parseNumber(e.target.value)||0) : e.target.value;
  state.editingMaestro.descuentos_financieros[idx][field] = val;
}

// Un componente de la receta del kit. Al CONFIRMAR el campo se repinta la
// ficha, porque lo que cambia no es solo el texto: cambian el costo derivado
// del kit y cuántas unidades se pueden armar. En cada tecla mataría el foco.
export function handleCompKitInput(e) {
  if (!state.editingMaestro) return;
  const idx = parseInt(e.target.dataset.compKit);
  const field = e.target.dataset.compField;
  if (!Array.isArray(state.editingMaestro._componentesKit)) state.editingMaestro._componentesKit = [];
  if (!state.editingMaestro._componentesKit[idx]) state.editingMaestro._componentesKit[idx] = { articulo: "", cantidad: 1 };
  state.editingMaestro._componentesKit[idx][field] =
    field === "cantidad" ? (parseNumber(e.target.value) || 0) : e.target.value;
  if (e.type === "change") showMaestroForm("productos", state.editingMaestro);
}

export function handleContactoInput(e) {
  if (!state.editingMaestro) return;
  const idx = parseInt(e.target.dataset.contacto);
  const field = e.target.dataset.contactoField;
  if (!state.editingMaestro._contactos) state.editingMaestro._contactos = [];
  if (!state.editingMaestro._contactos[idx]) state.editingMaestro._contactos[idx] = {};
  state.editingMaestro._contactos[idx][field] = e.target.value;
}

export function handleNominaAjusteInput(e) {
  const liq = state.nominaLiquidacionActual;
  if (!liq) return;
  const empleadoId = e.target.dataset.nominaAjuste;
  const campo = e.target.dataset.nominaCampo; // "horasExtra" | "otrosDevengados" | "otrasDeducciones"
  const valor = parseNumber(e.target.value) || 0;
  const idx = liq.detalle_empleados.findIndex(d => d.empleadoId === empleadoId);
  if (idx < 0) return;
  const det = liq.detalle_empleados[idx];
  const ajustes = { horasExtra: 0, otrosDevengados: 0, otrasDeducciones: 0, ...(det._ajustes || {}), [campo]: valor };
  const empleado = (state.data.empleados || []).find(emp => emp.id === empleadoId);
  if (!empleado) return;
  const parametrosNomina = getParametrosNomina();
  const periodo = { desde: liq.periodo_desde, hasta: liq.periodo_hasta };
  const extras = {
    comisiones: det.devengado.comisiones,
    horasExtra: ajustes.horasExtra > 0 ? [{ concepto: "Horas extra", valor: ajustes.horasExtra }] : [],
    otrosDevengados: ajustes.otrosDevengados > 0 ? [{ concepto: "Otros devengados", valor: ajustes.otrosDevengados }] : [],
    otrasDeducciones: ajustes.otrasDeducciones
  };
  const resultado = liquidarEmpleado(empleado, periodo, parametrosNomina, extras);
  liq.detalle_empleados[idx] = { ...resultado, empleadoNombre: det.empleadoNombre, empleadoCargo: det.empleadoCargo, _ajustes: ajustes };
  render();
}

export function handleNCItemInput(e) {
  if (!state.editingNC) return;
  const idx = parseInt(e.target.dataset.ncItem);
  const item = state.editingNC.items[idx];
  let val = parseNumber(e.target.value);
  if (isNaN(val) || val < 0) val = 0;
  if (val > item.cantidad_factura) val = item.cantidad_factura;
  item.cantidad = val;
  renderNotaCreditoModal();
}

export function handleMultiOcpItemInput(e) {
  if (!state.multiOcp) return;
  const idx = parseInt(e.target.dataset.multiocpItem);
  const field = e.target.dataset.multiocpField;
  state.multiOcp.items[idx][field] = field === "grupo" ? e.target.value : e.target.value;
  renderMultiOcpModal();
}

export function handleMultiOcpProveedorInput(e) {
  if (!state.multiOcp) return;
  const g = e.target.dataset.multiocpGrupo;
  if (!state.multiOcp.grupos[g]) state.multiOcp.grupos[g] = { proveedor_nombre:"", proveedor_id:"" };
  state.multiOcp.grupos[g].proveedor_nombre = e.target.value;
}

// Margen FIJADO a mano en una escala (null si está vacío o fuera de rango). Es
// lo que decide quién manda: con margen fijado el precio se calcula desde él;
// sin margen fijado manda el precio escrito y el margen se muestra derivado.
export function margenFijadoEscala(esc) {
  if (!esc || esc.margen == null || esc.margen === "") return null;
  const m = parseNumber(esc.margen);
  return (m > 0 && m < 100) ? m : null;
}

const colorMargen = (m) => m == null ? "#64748b" : m < 20 ? "#dc2626" : m < 40 ? "#f59e0b" : "#10b981";

const inputEscala = (idx, sub, campo) =>
  document.querySelector(`[data-escala="${idx}"][data-escala-idx="${sub}"][data-escala-field="${campo}"]`);

// Repinta una escala sin re-renderizar (un render por tecla mataría el foco).
// Con `recalcularPrecio`, si la escala tiene margen fijado el precio se vuelve a
// calcular: el costo por unidad cambia con la cantidad, porque los costos de la
// línea se reparten entre más unidades — el mismo screen pesa menos en 1000 que
// en 100. Nunca se pisa el campo que el usuario tiene bajo el cursor.
export function refrescarEscala(idx, sub, recalcularPrecio) {
  const it = state.editingDoc && state.editingDoc.items && state.editingDoc.items[idx];
  const esc = it && Array.isArray(it._escalas) ? it._escalas[sub] : null;
  if (!esc) return;
  const cant = parseNumber(esc.cantidad) || 0;
  const cu = costoUnitarioEscala(it, cant);
  const mFijo = margenFijadoEscala(esc);

  if (recalcularPrecio && mFijo != null && cu > 0) {
    const nuevo = Math.round(cu / (1 - mFijo / 100));
    if (nuevo > 0) {
      esc.precio_unitario = nuevo;
      const inp = inputEscala(idx, sub, "precio_unitario");
      if (inp && document.activeElement !== inp) inp.value = nuevo;
    }
  }

  const pu = parseNumber(esc.precio_unitario) || 0;
  const celdaTotal = document.querySelector(`[data-escala-total="${idx}-${sub}"]`);
  if (celdaTotal) celdaTotal.textContent = fmtCOP(cant * pu);

  const inpMargen = inputEscala(idx, sub, "margen");
  if (inpMargen) {
    const m = mFijo != null ? mFijo : ((pu > 0 && cu > 0) ? (1 - cu / pu) * 100 : null);
    if (document.activeElement !== inpMargen) inpMargen.value = m == null ? "" : m.toFixed(1);
    inpMargen.style.color = colorMargen(m);
  }
}

// Escalas de cantidad de una línea: cada cantidad con su precio y su margen.
// Precio y margen son dos caras de lo mismo, igual que en la línea: escribir uno
// mueve el otro, con el costo de esa cantidad de por medio.
export function handleEscalaInput(e) {
  const idx = parseInt(e.target.dataset.escala, 10);
  const sub = parseInt(e.target.dataset.escalaIdx, 10);
  const field = e.target.dataset.escalaField;
  const it = state.editingDoc && state.editingDoc.items && state.editingDoc.items[idx];
  if (!it || !Array.isArray(it._escalas) || !it._escalas[sub]) return;
  it._escalas[sub][field] = e.target.value;
  programarAutoguardado();   // las escalas también son trabajo que no se puede perder

  // ESCRIBO UN PRECIO → el margen se suelta y pasa a ser un valor derivado, así
  // el precio queda exactamente como se escribió sin que un redondeo lo mueva.
  if (field === "precio_unitario") it._escalas[sub].margen = null;

  refrescarEscala(idx, sub, field === "margen" || field === "cantidad");
}

// Costos de una línea de la cotización. Se escribe directo en el ítem y solo se
// refrescan los dos números que cambian —el total de la fila y el de la línea—
// en vez de re-renderizar: un render en cada tecla mataría el foco del campo.
export function handleCostoLineaInput(e) {
  const idx = parseInt(e.target.dataset.costoLinea);
  const sub = parseInt(e.target.dataset.costoIdx);
  const field = e.target.dataset.costoField;
  const it = state.editingDoc && state.editingDoc.items && state.editingDoc.items[idx];
  if (!it) return;
  if (!it._costosLinea) it._costosLinea = [];
  if (!it._costosLinea[sub]) return;
  it._costosLinea[sub][field] = e.target.value;
  if (field !== "cantidad" && field !== "valor_tercero") return;

  // Los costos de la línea se reparten entre las unidades de cada escala, así
  // que cambiarlos mueve el costo por unidad —y con él el precio de las escalas
  // que tengan margen fijado— de todas las cantidades de esta línea.
  (it._escalas || []).forEach((_, j) => refrescarEscala(idx, j, true));

  const c = it._costosLinea[sub];
  const fila = e.target.closest("tr");
  if (fila) {
    const celdas = fila.querySelectorAll("td");
    const celdaTotal = celdas[celdas.length - 2];
    if (celdaTotal) celdaTotal.textContent = fmtCOP((parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0));
  }
  recalcPrecioLinea(idx);
  const totalLinea = it._costosLinea.reduce((sum, x) => sum + (parseNumber(x.cantidad)||0) * (parseNumber(x.valor_tercero)||0), 0);
  // El pie "Costos de la línea" está FUERA de la tabla interna: buscarlo desde
  // la celda del input no lo encontraba nunca y el total se quedaba en $ 0.
  const caja = e.target.closest("table") ? e.target.closest("table").parentElement : null;
  if (caja) {
    caja.querySelectorAll("div").forEach(div => {
      if (div.textContent && div.textContent.trim().startsWith("Costos de la línea:")) {
        div.textContent = "Costos de la línea: " + fmtCOP(totalLinea);
      }
    });
  }
}

export function handleCostoConceptoInput(e) {
  const idx = parseInt(e.target.dataset.costoConcepto);
  const field = e.target.dataset.costoField;
  if (!state.editingDoc._conceptosCosto) state.editingDoc._conceptosCosto = [];
  state.editingDoc._conceptosCosto[idx][field] = e.target.value;

  // El destino elegido en la fila (orden de compra o cuenta de cobro) se
  // APRENDE: el mismo concepto suele ir siempre por la misma vía, y así la
  // próxima orden llega con la sugerencia puesta. Se repinta la fila para
  // mostrar el aviso que corresponda (falta el tercero, documento creado).
  if (field === "_via" || field === "_ocpAdemas") {
    if (e.type !== "change") return;   // un <select> dispara input y change
    const c = state.editingDoc._conceptosCosto[idx];
    if (field === "_via" && c._via && c._via !== "nada") aprenderVia(c.concepto, c._via);
    // Elegir orden de compra abre la segunda pregunta (¿lleva IVA?) y la
    // respuesta cambia el aviso de la celda: en los dos casos se repinta.
    renderDocFormModal();
    return;
  }

  // El producto al que apunta el costo y la línea que compone cambian los
  // avisos de la fila —el régimen de IVA, y el "sale de bodega al remisionar"
  // del kit—, así que hay que volver a pintarla. Solo al CONFIRMAR el campo
  // (change), nunca en cada tecla: eso mataría el foco mientras se escribe.
  if ((field === "articulo" || field === "_articuloOrigen") && e.type === "change") {
    renderDocFormModal();
    return;
  }

  if (field === "cantidad" || field === "valor_tercero") {
    const c = state.editingDoc._conceptosCosto[idx];
    const rowTotal = (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0);
    // La celda del total se busca por su propia marca, no por su posición: la
    // fila ganó una columna (el destino del costo) y contar desde el final
    // dejaba el total escribiéndose en la columna equivocada.
    const totalCell = document.querySelector(`[data-costo-total="${idx}"]`);
    if (totalCell) totalCell.textContent = fmtCOP(rowTotal);
    // Actualizar total general de costos
    const grandTotal = (state.editingDoc._conceptosCosto||[]).reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);
    document.querySelectorAll('div').forEach(div => {
      if (div.textContent && div.textContent.trim().startsWith("Total Costos:")) {
        div.textContent = "Total Costos: " + fmtCOP(grandTotal);
      }
    });
  }
}

export function handleLiqCostoInput(e) {
  const idx = parseInt(e.target.dataset.liqConcepto);
  const field = e.target.dataset.liqField;
  if (!state.liqConceptos || !state.liqConceptos[idx]) return;
  state.liqConceptos[idx][field] = e.target.value;

  // El destino del costo cambia lo que la celda dice debajo (la sugerencia, o
  // que falta el tercero), así que se repinta la ventana.
  if (field === "_via" || field === "_ocpAdemas") { renderLiquidacionModal(); return; }

  if (field === "cantidad" || field === "valor_tercero") {
    const c = state.liqConceptos[idx];
    const rowTotal = (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0);
    // La celda del total se busca por su marca, NO por posición: contarla desde
    // el final se rompió en cuanto la tabla ganó la columna «¿Qué se crea?» —
    // el total se escribía encima del selector de destino.
    const totalCell = document.querySelector(`[data-liq-total="${idx}"]`);
    if (totalCell) totalCell.textContent = fmtCOP(rowTotal);
    // Actualizar total general de "otros costos"
    const grandTotal = (state.liqConceptos||[]).reduce((s,c) => s + (parseNumber(c.cantidad)||0) * (parseNumber(c.valor_tercero)||0), 0);
    const totalBox = document.getElementById("liq-otros-total");
    if (totalBox) totalBox.textContent = "Total otros costos: " + fmtCOP(grandTotal);
  }
}

// Costo unitario REAL de una línea de cotización: el costo base del producto
// más los costos propios de la línea (marcación, domicilio…) repartidos entre
// las unidades. Es lo que hace que el precio baje al subir la cantidad: el
// mismo screen de valor fijo pesa menos por unidad en 100 que en 50.
export function costoUnitarioItem(it, costoBase) {
  const cant = parseNumber(it.cantidad) || 0;
  const costosLinea = (it._costosLinea || []).reduce((s, c) =>
    s + (parseNumber(c.cantidad) || 0) * (parseNumber(c.valor_tercero) || 0), 0);
  return (parseNumber(costoBase) || 0) + (cant > 0 ? costosLinea / cant : 0);
}

export function calcPrecioManualItem(it) {
  const costo = costoUnitarioItem(it, it._costoManual);
  const margen = parseNumber(it._margenManual) || 0;
  const comp = 1 - (margen / 100);
  return (comp > 0 && costo > 0) ? Math.round(costo / comp) : 0;
}

// Margen configurado de un producto de catálogo. Si la ficha no lo trae, se
// deriva de costo y precio de venta; null si no hay con qué calcular.
export function margenProducto(prod) {
  if (!prod) return null;
  const m = parseNumber(prod.margen);
  if (m > 0 && m < 100) return m;
  const costo = costoBaseProducto(prod);
  const pv = parseNumber(prod.precio_venta) || 0;
  if (costo > 0 && pv > costo) return (1 - costo / pv) * 100;
  return null;
}

// Margen efectivo de una línea de catálogo: el escrito en la propia línea
// (_margenManual) manda sobre el del producto. Editarlo NUNCA toca la ficha
// del producto en maestros — es un ajuste solo de esta cotización.
export function margenEfectivoLinea(it, prod) {
  const m = parseNumber(it._margenManual);
  if (m > 0 && m < 100) return m;
  return margenProducto(prod);
}

// Precio de una línea de catálogo CON costos de línea: la rentabilidad
// (la de la línea si se ajustó, si no la del producto) se mantiene y lo que
// cambia es el costo por unidad. Devuelve null si no hay margen con qué
// calcular (el precio se deja como esté).
export function calcPrecioCatalogoItem(it, prod) {
  const margen = margenEfectivoLinea(it, prod);
  if (margen == null) return null;
  const costoUnit = costoUnitarioItem(it, costoBaseProducto(prod));
  const comp = 1 - (margen / 100);
  return (comp > 0 && costoUnit > 0) ? Math.round(costoUnit / comp) : null;
}

// ¿La línea tiene costos con valor? (una fila vacía recién agregada no cuenta)
export function itemConCostosLinea(it) {
  return (it._costosLinea || []).some(c => (parseNumber(c.valor_tercero) || 0) > 0);
}

// Recalcula el precio de la línea cuando cambian la cantidad o sus costos, sin
// re-renderizar (el render mataría el foco del campo que se está escribiendo).
export function recalcPrecioLinea(idx) {
  const it = state.editingDoc && state.editingDoc.items && state.editingDoc.items[idx];
  if (!it || state.editingTipo !== "CT" || !it.articulo) return;
  const prod = (state.data.productos || []).find(p => p.nombre === it.articulo);
  // Sin margen fijado manda el PRECIO tecleado: no se recalcula, solo se
  // refresca el margen que resulta con la cantidad nueva.
  const hayMargen = margenFijadoLinea(it) != null;
  // Un precio TECLEADO manda aunque la línea tenga costos asociados: solo se
  // recalcula si hay margen fijado, o si el precio nunca se tecleó (salió del
  // costo y debe seguir saliendo de él).
  if (!hayMargen && (it._precioManual || !(prod && itemConCostosLinea(it)))) {
    const m = margenDesdePrecio(costoEfectivoLinea(it, prod), parseNumber(it.precio_unitario) || 0);
    pintarMargenLinea(idx, m != null ? m.toFixed(1) : "");
    pintarCostoLinea(idx, it, prod);
    updateRowTotal(idx);
    return;
  }
  let nuevo = null;
  if (!prod) nuevo = calcPrecioManualItem(it);
  else nuevo = calcPrecioCatalogoItem(it, prod);
  if (nuevo == null || nuevo <= 0) return;
  it.precio_unitario = nuevo;
  const cell = document.querySelector(`[data-punit-display="${idx}"]`);
  if (cell) cell.textContent = fmtCOP(nuevo);
  // El precio de la cotización es un campo EDITABLE (teclearlo suelta el margen
  // y es una vía válida de cotizar), así que la celda de solo lectura de arriba
  // casi nunca existe. Sin pintar el input, el precio recalculado se quedaba en
  // el estado sin llegar a la pantalla: el usuario veía el precio anterior junto
  // a un total ya calculado con el nuevo — dos números que no cuadran entre sí.
  pintarPrecioLinea(idx, it);
  pintarCostoLinea(idx, it, prod);
  updateRowTotal(idx);
}

// El costo unitario REAL de la línea, que sube cuando se cargan costos
// asociados. Se repinta en vivo por el mismo motivo que el precio: verlo subir
// es lo que permite creerle al precio que sale de él.
export function pintarCostoLinea(idx, it, prod) {
  const cell = document.querySelector(`[data-costo-display="${idx}"]`);
  if (!cell) return;
  cell.innerHTML = costoLineaHTML(it, prod, cell.dataset.costoModo || "completo");
}

// Costo unitario de la línea, DESGLOSADO cuando hay costos asociados: sin el
// desglose el número no coincide con el de la ficha del producto y parece un
// error. Con él se ve de dónde sale cada peso, y por qué el precio es el que es.
//
// `modo` = "completo" cuando la celda muestra el costo (producto de catálogo),
// "extra" cuando el costo base ya está en un input que teclea el usuario y aquí
// solo falta decirle cuál es el costo real.
export function costoLineaHTML(it, prod, modo = "completo") {
  const base = prod ? costoBaseProducto(prod) : (parseNumber(it._costoManual) || 0);
  const total = costoUnitarioItem(it, base);
  const extra = total - base;
  const ayuda = "Costo base + los costos asociados de la línea repartidos entre las unidades cotizadas";
  if (modo === "extra") {
    if (extra <= 0) return "";
    return `<span style="color:#7c3aed;font-weight:700;" title="${ayuda}">real c/u ${fmtCOP(total)}</span>
      <span style="color:${C.muted};font-weight:600;"> (+${fmtCOP(extra)})</span>`;
  }
  if (extra <= 0) return `<div style="font-weight:700;color:${C.text};">${fmtCOP(total)}</div>`;
  return `<div style="font-weight:700;color:${C.text};">${fmtCOP(total)}</div>
    <div style="font-size:9px;color:#7c3aed;font-weight:700;" title="${ayuda}">
      ${fmtCOP(base)} + ${fmtCOP(extra)} de costos</div>`;
}

// ─── Precio de venta ⇄ margen de utilidad ────────────────────────────────────
// Son dos caras de lo mismo, con el costo de por medio. Escribir cualquiera de
// los dos actualiza el otro en vivo, tanto si el artículo viene del catálogo
// como si se escribió a mano (ahí el costo lo pone el usuario).

// Costo unitario efectivo de la línea (incluye sus costos propios repartidos):
// del catálogo si el artículo existe, escrito a mano si no.
function costoEfectivoLinea(it, prod) {
  return costoUnitarioItem(it, prod ? costoBaseProducto(prod) : it._costoManual);
}

// Margen que resulta de un precio dado. null si no hay con qué calcularlo.
function margenDesdePrecio(costo, precio) {
  return (precio > 0 && costo > 0) ? (1 - costo / precio) * 100 : null;
}

// Margen FIJADO a mano en la línea (null si está vacío o fuera de rango). Es lo
// que decide quién manda: con margen fijado, el precio se calcula desde él;
// sin margen fijado, manda el precio tecleado y el margen se deriva.
export function margenFijadoLinea(it) {
  if (it._margenManual == null || it._margenManual === "") return null;
  const m = parseNumber(it._margenManual);
  return (m > 0 && m < 100) ? m : null;
}

// Refrescan un campo sin re-renderizar (un render mataría el foco de quien
// está escribiendo). Nunca pisan el campo que el usuario tiene bajo el cursor.
function pintarMargenLinea(idx, texto) {
  const el = document.querySelector(`input[data-item="${idx}"][data-field="_margenManual"]`);
  if (el && document.activeElement !== el) el.value = texto;
}

function pintarPrecioLinea(idx, it) {
  const cell = document.querySelector(`[data-punit-display="${idx}"]`);
  if (cell) cell.textContent = fmtCOP(it.precio_unitario);
  const el = document.querySelector(`input[data-item="${idx}"][data-field="precio_unitario"]`);
  if (el && document.activeElement !== el) el.value = it.precio_unitario;
  // La pista de debajo del campo dice de qué costo salió el precio: si no se
  // refresca, contradice al número que acaba de cambiar.
  const pista = document.querySelector(`[data-punit-hint="${idx}"]`);
  if (pista) {
    const prod = (state.data.productos || []).find(p => p.nombre === it.articulo);
    pista.textContent = margenFijadoLinea(it) != null || (prod && itemConCostosLinea(it) && !it._precioManual)
      ? `↻ del costo ${fmtCOP(costoEfectivoLinea(it, prod))}` : "";
  }
}

export function handleItemInput(e) {
  const idx = parseInt(e.target.dataset.item);
  const field = e.target.dataset.field;
  // Guardar el valor crudo del input (sin convertir) para permitir edición libre
  state.editingDoc.items[idx][field] = e.target.value;
  programarAutoguardado();   // se guarda solo unos segundos después de escribir
  // Recalcular total del ítem en vivo (sin re-renderizar para no perder el foco)
  if (["cantidad","precio_unitario"].includes(field)) {
    if (field === "precio_unitario") {
      // ESCRIBO UN PRECIO → sale el margen respecto al costo.
      // El margen fijado se suelta (el precio tecleado manda) y el margen pasa
      // a ser un valor DERIVADO: así el precio queda exactamente como se
      // escribió, sin que un redondeo de ida y vuelta lo mueva.
      const it = state.editingDoc.items[idx];
      const prod = (state.data.productos || []).find(p => p.nombre === it.articulo);
      const costoVal = costoEfectivoLinea(it, prod);
      const m = margenDesdePrecio(costoVal, parseNumber(it.precio_unitario) || 0);
      it._margenManual = null;
      // Y queda MARCADO como tecleado: es lo que hace que sobreviva a guardar
      // y volver a abrir, y a que cambien la cantidad o los costos de la línea.
      // Sin la marca, una línea de catálogo con costos asociados volvía a
      // calcularse desde el margen del producto al abrir la cotización, y el
      // precio que se había escrito aparecía cambiado.
      it._precioManual = true;
      pintarMargenLinea(idx, m != null ? m.toFixed(1) : "");
    }
    updateRowTotal(idx);
    if (field === "cantidad") recalcPrecioLinea(idx);
  }
  // Costo/margen de la línea. Con producto de catálogo, el margen escrito aquí
  // es un ajuste SOLO de esta cotización (no toca la ficha del producto).
  if (field === "_costoManual" || field === "_margenManual") {
    const it = state.editingDoc.items[idx];
    const prod = (state.data.productos || []).find(p => p.nombre === it.articulo);
    const hayMargen = margenFijadoLinea(it) != null;

    if (field === "_margenManual" && !hayMargen) {
      // Campo de margen vacío o fuera de rango (lo están borrando para
      // reescribirlo): no se toca el precio hasta que haya un número usable.
    } else if (hayMargen) {
      // ESCRIBO UN MARGEN → sale el precio de venta desde el costo. El último
      // que se escribe manda: el margen suelta la marca de precio tecleado.
      if (field === "_margenManual") it._precioManual = false;
      const nuevo = prod ? calcPrecioCatalogoItem(it, prod) : calcPrecioManualItem(it);
      if (nuevo != null && nuevo > 0) {
        it.precio_unitario = nuevo;
        pintarPrecioLinea(idx, it);
      }
    } else {
      // Cambió el COSTO y no hay margen fijado: se respeta el precio ya puesto
      // y se muestra el margen que ahora resulta.
      const m = margenDesdePrecio(costoEfectivoLinea(it, prod), parseNumber(it.precio_unitario) || 0);
      pintarMargenLinea(idx, m != null ? m.toFixed(1) : "");
    }
    pintarCostoLinea(idx, it, prod);
    updateRowTotal(idx);
  }
  // Al terminar de escribir el artículo, refrescar la fila completa (badge de stock,
  // botón "Crear producto" y campos de costo/margen aparecen o desaparecen según coincida con el catálogo)
  if (field === "articulo" && e.type === "change") {
    renderDocFormModal();
  }
}

export function updateRowTotal(idx) {
  const it = state.editingDoc.items[idx];
  it.total = parseNumber(it.cantidad) * parseNumber(it.precio_unitario);
  // Actualizar solo la celda del total (y margen si aplica) sin re-renderizar todo
  const row = document.querySelector(`input[data-item="${idx}"][data-field="cantidad"]`);
  if (row && row.closest("tr")) {
    const cells = row.closest("tr").querySelectorAll("td");
    const showCostoMargen = state.editingTipo === "CT" || state.editingTipo === "OP";
    // Última celda = botón eliminar. Si hay Costo/Margen, antes van: ... Total, Costo, Margen, Eliminar
    const totalCell = cells[cells.length - (showCostoMargen ? 4 : 2)];
    if (totalCell && !totalCell.querySelector("input")) {
      totalCell.textContent = fmtCOP(it.total);
    }
    if (showCostoMargen) {
      const margenCell = cells[cells.length - 2];
      if (margenCell && !margenCell.querySelector("input")) {
        const prod = (state.data.productos||[]).find(p => p.nombre === it.articulo);
        const costoVal = prod ? costoUnitarioItem(it, costoBaseProducto(prod)) : 0;
        const precioVenta = parseNumber(it.precio_unitario) || 0;
        if (prod && precioVenta > 0) {
          const margenPct = (1 - (costoVal / precioVenta)) * 100;
          const margenColor = margenPct < 20 ? C.red : margenPct < 40 ? C.amber : "#10b981";
          margenCell.textContent = margenPct.toFixed(1) + "%";
          margenCell.style.color = margenColor;
          margenCell.style.fontWeight = "700";
        } else {
          margenCell.textContent = "—";
          margenCell.style.color = C.muted;
          margenCell.style.fontWeight = "normal";
        }
      }
    }
  }
  updateTotalsDisplay();
}

export function updateTotalsDisplay() {
  if (!state.editingDoc || state.editingTipo === "RC") return;
  // Los ítems cotizados por cantidad no suman: la cantidad la define el cliente.
  // (Debe coincidir con el cálculo del formulario y del guardado, o el total
  // cambiaría con solo tocar cualquier otro campo.)
  const items = (state.editingDoc.items||[]).filter(aportaATotales);
  const subtotal = items.reduce((s, it) =>
    s + (parseNumber(it.cantidad) * parseNumber(it.precio_unitario)), 0);
  const desglose = desgloseIVA(items.map(it => ({
    ...it, total: parseNumber(it.cantidad) * parseNumber(it.precio_unitario)
  })));
  const iva = desglose.iva;
  const total = subtotal + iva;
  state.editingDoc._subtotal = subtotal;
  state.editingDoc._iva = iva;
  state.editingDoc._total = total;
  // Actualizar el bloque de totales sin re-renderizar
  const totalsBox = document.getElementById("form-totals-box");
  if (totalsBox) {
    const info = DOC_INFO[state.editingTipo];
    const margenInfo = calcularMargenTotal(state.editingDoc.items);
    const margenHTML = margenInfo ? (() => {
      const color = margenInfo.pct < 20 ? C.red : margenInfo.pct < 40 ? C.amber : "#10b981";
      return `<div style="font-size:12px;margin-top:6px;padding-top:6px;border-top:1px dashed ${C.border};">Margen de utilidad total: <strong style="color:${color};">${margenInfo.pct.toFixed(1)}%</strong></div>`;
    })() : "";
    const soloEscalas = (state.editingDoc.items || []).length > 0 && items.length === 0;
    totalsBox.innerHTML = `
      ${soloEscalas ? `
      <div style="text-align:left;font-size:11.5px;color:${C.text};">
        <strong style="color:${C.blue};">📊 Cotización por cantidad.</strong>
        No hay un total del documento: cada cantidad tiene el suyo. Se define cuando el cliente
        confirme la cantidad (se pregunta al convertirla en Orden de Producción).
      </div>` : `
      <div style="font-size:12px;color:${C.muted};margin-bottom:4px;">Subtotal: <strong style="color:${C.text};">${fmtCOP(subtotal)}</strong></div>
      ${desglose.mezclado
        ? desglose.grupos.map(g => `<div style="font-size:11.5px;color:${C.muted};margin-bottom:3px;">${g.lbl} sobre ${fmtCOP(g.base)}: <strong style="color:${C.text};">${fmtCOP(g.iva)}</strong></div>`).join("")
        : `<div style="font-size:12px;color:${C.muted};margin-bottom:4px;">${desglose.grupos[0] ? desglose.grupos[0].lbl : "IVA " + ivaPct() + "%"}: <strong style="color:${C.text};">${fmtCOP(iva)}</strong></div>`}
      <div style="font-size:16px;font-weight:800;color:${info.color};">TOTAL: ${fmtCOP(total)}</div>`}
      ${margenHTML}
    `;
  }
}

export function exportJSON() {
  // Capturar el 100% de los datos: todos los módulos de datos + todas las configuraciones
  const backup = {
    version: "1.1",
    timestamp: new Date().toISOString(),
    data: {
      clientes: state.data.clientes || [],
      proveedores: state.data.proveedores || [],
      productos: state.data.productos || [],
      cotizaciones: state.data.cotizaciones || [],
      pedidos: state.data.pedidos || [],
      ocp: state.data.ocp || [],
      remisiones: state.data.remisiones || [],
      inventario: state.data.inventario || [],
      puc: state.data.puc || [],
      asientos: state.data.asientos || [],
      facturas: state.data.facturas || [],
      empleados: state.data.empleados || [],
      notas_credito: state.data.notas_credito || [],
      alertas_enviadas: state.data.alertas_enviadas || []
    },
    config: {
      empresa: (() => { try { return JSON.parse(localStorage.getItem("erp:empresa_config") || "null"); } catch { return null; } })(),
      alertas: (() => { try { return JSON.parse(localStorage.getItem("erp:alert_config") || "null"); } catch { return null; } })(),
      // Credenciales fuera del respaldo: solo se exporta el ambiente de Dataico, nunca la API key
      dataico: (() => { try { const c = JSON.parse(localStorage.getItem("erp:dataico_config") || "null"); if (c) delete c.api_key; return c; } catch { return null; } })(),
      ia: (() => { try { const c = JSON.parse(localStorage.getItem("erp:ia_config") || "null"); if (c) delete c.apiKey; return c; } catch { return null; } })(),
      tabla_comisiones: (() => { try { return JSON.parse(localStorage.getItem("erp:tabla_comisiones") || "null"); } catch { return null; } })()
    }
  };
  const blob = new Blob([JSON.stringify(backup, null, 2)], { type:"application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = BRAND.archivo_prefijo + "_Respaldo_" + today() + ".json";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  // Registrar fecha del último backup exportado
  try { localStorage.setItem("erp:last_backup", new Date().toISOString()); } catch {}
}

export function handleImportFile(e) {
  const file = e.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (ev) => {
    try {
      const parsed = JSON.parse(ev.target.result);

      // Validar estructura mínima
      if (!parsed.data && !parsed.config) {
        alert("❌ Archivo no válido: no contiene datos ni configuración reconocibles.");
        return;
      }

      // Advertir si la versión es diferente
      const versionArchivo = parsed.version || "desconocida";
      const versionActual = "1.1";
      if (versionArchivo !== versionActual) {
        const ok = confirm(
          `⚠️ Advertencia de versión\n\n` +
          `El backup es de versión ${versionArchivo} y la versión actual del ERP es ${versionActual}.\n\n` +
          `Es posible que algunos datos no se restauren correctamente.\n\n` +
          `¿Deseas continuar de todas formas?`
        );
        if (!ok) return;
      }

      // Verificar que hay al menos un array de datos reconocido
      const clavesReconocidas = parsed.data ? Object.keys(parsed.data).filter(k => KEYS[k] && Array.isArray(parsed.data[k])) : [];
      if (clavesReconocidas.length === 0 && !parsed.config) {
        alert("❌ El archivo no contiene datos válidos para este ERP.");
        return;
      }

      if (!confirm(
        `✅ Archivo validado (versión ${versionArchivo})\n\n` +
        `Se restaurarán: ${clavesReconocidas.length} módulos de datos` +
        (parsed.timestamp ? `\nFecha del backup: ${new Date(parsed.timestamp).toLocaleString("es-CO")}` : "") +
        `\n\n⚠️ Esto REEMPLAZARÁ todos tus datos actuales. ¿Continuar?`
      )) return;

      // Restaurar arrays de datos
      if (parsed.data) {
        Object.entries(parsed.data).forEach(([k, v]) => {
          if (Array.isArray(v) && KEYS[k]) saveData(k, v);
        });
      }

      // Restaurar configuraciones (empresa, alertas, dataico, IA, tabla de comisiones)
      if (parsed.config) {
        if (parsed.config.empresa) { try { localStorage.setItem("erp:empresa_config", JSON.stringify(parsed.config.empresa)); } catch {} }
        if (parsed.config.alertas) { try { localStorage.setItem("erp:alert_config", JSON.stringify(parsed.config.alertas)); } catch {} }
        // Respaldos antiguos podían traer credenciales: se descartan al importar
        if (parsed.config.dataico) { try { const c = { ...parsed.config.dataico }; delete c.api_key; localStorage.setItem("erp:dataico_config", JSON.stringify(c)); } catch {} }
        if (parsed.config.ia) { try { const c = { ...parsed.config.ia }; delete c.apiKey; localStorage.setItem("erp:ia_config", JSON.stringify(c)); } catch {} }
        if (parsed.config.tabla_comisiones) { try { localStorage.setItem("erp:tabla_comisiones", JSON.stringify(parsed.config.tabla_comisiones)); } catch {} }
      }

      // Registrar fecha del último backup restaurado
      try { localStorage.setItem("erp:last_backup", new Date().toISOString()); } catch {}
      registrarEvento("configuracion", "respaldo", "restaurar_respaldo", { referencia: "Respaldo", detalle: {
        fecha_respaldo: parsed.timestamp ? new Date(parsed.timestamp).toLocaleString("es-CO") : "—",
        version: versionArchivo, modulos: clavesReconocidas.join(", ") || "solo configuración"
      } });

      alert("✅ Datos y configuración importados correctamente. La página se recargará.");
      location.reload();
    } catch {
      alert(`❌ Error al leer el archivo. Asegúrate de que sea un backup JSON válido de ${BRAND.producto}.`);
    }
  };
  reader.readAsText(file);
}
